<template>
  <ul class="app-notifications">
    <li v-for="item in notifies" :key="item.id">
      <div class="app-notifications__container">
        <NotificationsItem v-bind="{ item }">
          <template #action>
            <button class="app-notifications__remove" @click="handleRemove(item.id)">
              <XCircleIcon aria-hidden="true" />
            </button>
          </template>
        </NotificationsItem>
      </div>
    </li>
    <li v-for="(item, index) in errors" :key="index">
      <router-link
        :to="{
          name: ROUTE_NAME.TRANSACTIONS_ITEM,
          params: { id: item.id },
        }"
        class="app-notifications__container"
        @click="handleClickItem"
      >
        <NotificationsItem v-bind="{ item }" @remove="handleRemove" />
      </router-link>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { TaskNotify } from './utils/types'

import { ROUTE_NAME } from '@/const'

import { handleCatchedError } from '@/helpers/common'

import { useTasksStore } from '@/store/tasks'

import { XCircleIcon } from '@heroicons/vue/24/outline'
import NotificationsItem from './NotificationsItem.vue'

type Props = {
  notifies: TaskNotify[]
  errors: TaskNotify[]
}

type Emits = {
  'click:item': []
}

defineProps<Props>()
const emit = defineEmits<Emits>()

defineOptions({ name: 'AppNotifications' })

const tasksStore = useTasksStore()

const handleRemove = (taskId: string) => {
  try {
    tasksStore.deleteEntry(taskId)
  } catch (e) {
    handleCatchedError(e as string, { taskId })
  }
}

const handleClickItem = () => {
  emit('click:item')
}
</script>

<style>
.app-notifications {
  @apply divide-y divide-gray-200 dark:divide-gray-700;
  @apply -mx-6 sm:mx-0;
  @apply sm:w-80;

  &__container {
    @apply block;
    @apply hover:bg-gray-50 dark:hover:bg-gray-850;
  }

  &__remove {
    @apply p-1 -mr-1;
    @apply shrink-0;
    @apply cursor-pointer;
    @apply text-red-400 hover:text-red-600;

    svg {
      @apply w-6 sm:w-4 h-auto;
    }
  }
}
</style>
